import { Grid, Typography } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import React from 'react'
import { Controller, useForm, useFormContext } from 'react-hook-form'
import { GlobalTextField } from '../../../Core/Input/ControlledTextField'
import EventIcon from '@material-ui/icons/Event'
import { EMAIL_REGEX } from '../../../../Constants'
import { FirebaseConfigKey, FirebaseService } from '../../../../services/FirebaseService'
import { generalPhoneNumberRegex, isOver18 } from '../../../../services/utils'

export const OwnerProfileSection = props => {
  const methods = useFormContext()
  const validatePhoneNumber = phoneNumber => !phoneNumber || generalPhoneNumberRegex.test(phoneNumber)

  return (
    <React.Fragment>
      <Grid container spacing={3}>
        <Grid item xs={12} md={4}>
          <Typography className="grey">{'First Name'}</Typography>
          <GlobalTextField
            fullWidth
            name="first_name"
            register={methods.register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={methods.errors}
            helperText={!!methods.errors.first_name && 'Required'}
            inputRef={methods.register({ required: true })}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography className="grey">{'Last Name'}</Typography>
          <GlobalTextField
            fullWidth
            name="last_name"
            register={methods.register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={methods.errors}
            helperText={!!methods.errors.last_name && 'Required'}
            inputRef={methods.register({ required: true })}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography className="grey">{'Date of Birth'}</Typography>
          <Controller
            as={
              <KeyboardDatePicker
                disableFuture
                fullWidth
                keyboardIcon={<EventIcon className="backbuttongray" />}
                openTo="year"
                views={['year', 'month', 'date']}
                error={!!methods.errors.date_of_birth}
                inputVariant="outlined"
                helperText={!!methods.errors.date_of_birth ? 'Must be 18 or older' : ''}
                format={FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)}
              />
            }
            onChange={date => {
              if (date && date.length > 0 && date[0] != null) {
                methods.setValue('date_of_birth', new Date(date[0]))
                return new Date(date[0])
              } else {
                methods.setValue('date_of_birth', null)
                return methods.getValues()['date_of_birth']
              }
            }}
            rules={{ validate: tim => isOver18(new Date(tim)), required: true }}
            name="date_of_birth"
            value={methods.watch('date_of_birth')}
            defaultValue={methods.watch('date_of_birth')}
            control={methods.control}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography className="grey">{'Phone Number'}</Typography>
          <GlobalTextField
            fullWidth
            inputRef={methods.register({ required: true, validate: validatePhoneNumber })}
            name="phone_number"
            validate={validatePhoneNumber}
            register={methods.register}
            errors={methods.errors}
            helperText={
              !!methods.errors.phone_number && (methods.errors.phone_number.type == 'required' ? 'Required' : 'Invalid phone number')
            }
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography className="grey">{'Email'}</Typography>
          <GlobalTextField
            disabled
            fullWidth
            name="email"
            type="email"
            register={methods.register}
            inputProps={{ style: { textTransform: 'uppercase' } }}
            errors={methods.errors}
            inputRef={methods.register({ required: true, pattern: { value: EMAIL_REGEX, message: 'Invalid email address' } })}
            helperText={!!methods.errors.email && (methods.errors.email.type == 'required' ? 'Required' : 'Invalid email address')}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  )
}
